/** Le versioni già pubblicate del listino di un fornitore, dalla più recente: da cosa nascono, quando, con o senza avvisi. */
import React from 'react';
import { Box, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../theme';
import type { Riepilogo, VersionePubblicata } from '../../services/listiniFornitoriService';
import { useFormatiListino } from './formati';

const CONTEGGI = [['nuovi', 'nuovi'], ['aumentati', 'salgono'], ['scesi', 'scendono'], ['invariati', 'invariati'], ['spariti', 'escono'], ['da_verificare', 'da_verificare']] as const satisfies ReadonlyArray<readonly [keyof Riepilogo, string]>;

export const StoriaDelListino: React.FC<{ versioni: VersionePubblicata[] }> = ({ versioni }) => {
  const { t } = useTranslation('listini');
  const f = useFormatiListino();
  if (!versioni.length) return null;
  return (
    <Box sx={{ borderTop: `1px solid ${tokens.color.line}`, pt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>{t('storia.titolo')}</Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small" sx={{ minWidth: 560, '& td': { borderBottom: `1px solid ${tokens.color.lineSoft}` } }}>
          <TableBody>
            {versioni.map((v) => (
              <TableRow key={v.numero}>
                <TableCell sx={{ fontWeight: 600, whiteSpace: 'nowrap', width: 110, verticalAlign: 'top' }}>{t('storia.versione', { numero: v.numero })}</TableCell>
                <TableCell>
                  <Typography variant="body2">{v.fonte.tipo === 'catalogo' ? t('storia.origine_catalogo') : t('fornitore.del_listino', { data: f.giorno(v.fonte.data_documento) })}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {t('storia.pubblicata', { quando: f.momento(v.pubblicata_il) })}
                    {v.avvisa_amministratori !== null && `, ${t(v.avvisa_amministratori ? 'storia.con_avvisi' : 'storia.senza_avvisi')}`}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {CONTEGGI.filter(([k]) => (v.riepilogo[k] ?? 0) > 0).map(([k, c]) => t(`conteggi.${c}`, { count: v.riepilogo[k] ?? 0 })).join(', ')}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};
